import { render, staticRenderFns } from "./P027.vue?vue&type=template&id=6b64d370"
import script from "./P027.vue?vue&type=script&lang=js"
export * from "./P027.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports